import { type ReactNode } from "react";
import { Outlet } from "react-router";
import { useAuth } from "../hooks/useAuth";

export interface ProtectedRouteProps {
  children?: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, login } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    login();
    return null;
  }

  return children ? <>{children}</> : <Outlet />;
}
